import React, {useState, useEffect} from "react";
import DataTable from "react-data-table-component";
import { Modal } from "react-bootstrap";
import PageHeader from "../../components/common/PageHeader";
import ScheduleServices from "../../services/ScheduleServices";
import useScheduleSubmit from "../../hooks/useScheduleSubmit";
import Error from "../../components/Input/Error";
import DropDownService from "../../services/DropDownService";
import dayjs from "dayjs";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync"; 
import Uploader from "../../components/imageuploader/Uploader";
import { useLocation } from 'react-router-dom';

function Schedule() {   
    const [rowData, setrowData] = useState([]);
    const [columnT, setcolumnT] = useState([]);
    const [siEditModal, setSiEditModal] = useState("");
    const [ScheduleId, setScheduleId] = useState(""); 
    const [clientData, setClientData] = useState([]); 
    const [EmployeeData, setEmployeeData] = useState([]);
    const { data, loading } = useAsync(() => ScheduleServices?.getAllSchedule());
    const { data: projectDropdown } = useAsync(() => DropDownService.projectDropDown());
    const location = useLocation();
    const { pathname } = location;

    const { data:permissionData } = useAsync(() => DropDownService.getModulePermissions({ path:pathname, userId:localStorage.id})); 
    var addPermission = typeof permissionData?.data?.add === 'undefined' ? 1: permissionData?.data?.add; 
    var viewPermission = typeof permissionData?.data?.view === 'undefined' ? 1: permissionData?.data?.view;
    var editPermission = typeof permissionData?.data?.edit === 'undefined' ? 1: permissionData?.data?.edit; 
    var deletePermission = typeof permissionData?.data?.delete === 'undefined' ? 1: permissionData?.data?.delete; 
    var listPermission = typeof permissionData?.data?.list === 'undefined' ? 1: permissionData?.data?.list; 

    console.log(" changed ");

    const {  
        register,
        errors,
        onSubmit,
        handleSubmit,  
        deleteSchedule, 
        isModal, 
        setIsModal,  
        ShowEditValues,
        isViewModal, setIsViewModal,
        status, setStatus, viewData,
        changeStatusRequest, changeStatusConfirm,
        isConfirmModal, setIsConfirmModal, handleConfirmSchedule,
        isDeleteModal,
        setIsDeleteModal,
        imageUrl, setImageUrl,
      } = useScheduleSubmit(siEditModal?._id);    
 
    useEffect(()=>{
        const getAllSchedule = async (data) => {
            const result = data;     
            setrowData(result?.data); 
             
            var rowData = result?.data;
            console.log("rowdtaa", rowData); 
            var columnTs = "";
            columnTs = [ 
                {
                    name: "CLIENT NAME",
                    selector: (rowData) => rowData?.clientId?.clientName, 
                    sortable: true,
                    cell: rowData => <div className="fw-bold ">{rowData?.clientId?.clientName}</div>,
                    minWidth: "250px"
                }, 
                {
                    name: "EMPLOYEE NAME", 
                    selector: (rowData) => rowData?.employeeId?.employeeName,
                    sortable: true,
                    cell: (rowData) => <div className="fw-bold ">{rowData?.employeeId?.employeeName}</div>
                }, 
                {
                    name: "PROJECT",
                    selector: (rowData) => rowData?.projectType?.projectName,
                    sortable: true
                },
                {
                    name: "MEETING DATE",
                    selector: (rowData) => dayjs(rowData?.scheduleDate).format("DD-MM-YYYY"),
                    sortable: true
                },
                { 
                    name: "STATUS",
                    selector: (rowData) => rowData?.status,
                    sortable: true,
                    cell: row => <span className={`badge ${row.status === "Completed" ? 'bg-success' : "bg-warning"}`}>{row.status}</span>
                },  
                {
                    name: "ACTION",
                    selector: (row) => { },  
                    sortable: true,
                    cell: (row) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                        {viewPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); ShowEditValues(row, "View"); setScheduleId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>)}
                        {editPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setSiEditModal(row); ShowEditValues(row, "Edit"); setScheduleId(row?._id) }}><i className="icofont-edit text-success"></i></button>)}
                        {deletePermission === 1 && (<button type="button" className="btn btn-outline-secondary deleterow" onClick={()=>{ setIsDeleteModal(true); setScheduleId(row?._id); }}><i className="icofont-ui-delete text-danger"></i></button>)}
                    </div>)
                }
            ] 
            setcolumnT(columnTs); 
            // setLoading(false);
        } 
     
        const getClientDropdownData = async () => {
            const result = await DropDownService.clientDropDown();
            setClientData(result); 
            // console.log(" getClientDropdown == ",result);
        } 
    
        const getEmpDropdownData = async () => {
            const result = await DropDownService.employeeDropDown(); 
            setEmployeeData(result); 
        }

        setTimeout(() => { 
            getAllSchedule(data);  
        }, 100);
        getClientDropdownData();
        getEmpDropdownData();
    }, [data]);

    return (
        <div className="container-xxl">
            <PageHeader addPermission={addPermission} headerTitle="Meeting" renderRight={() => {
                return <div className="col-auto d-flex w-sm-100">
                    <button className="btn btn-dark btn-set-task w-sm-100" onClick={() => { setIsModal(true); setScheduleId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>New Meeting</button>
                </div>
            }} />
            {listPermission === 1 && (
            <div className="row clearfix g-3">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <DataTable 
                                title="Meeting"  
                                columns={columnT}
                                data={rowData}
                                defaultSortField="title"
                                pagination 
                                selectableRows={false}
                                className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                highlightOnHover={true}
                                progressPending={loading}
                                progressComponent={<ModalLoading loading={loading} />}
                            />
                        </div>
                    </div>
                </div>
            </div> 
            )}
            <Modal centered show={isModal} backdrop={!isConfirmModal} onHide={() => { setIsModal(false); setSiEditModal("") }}>
                <form onSubmit={handleSubmit(onSubmit)}> 
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{ScheduleId !== "" && (typeof ScheduleId !== 'undefined') ? "Edit" : "New"} Meeting</Modal.Title>
                </Modal.Header> 
                <Modal.Body>
                    <div className="deadline-form">
                    
                            <div className="row g-3 mb-3"> 
                                <div className="col-lg-12"> 
                                    <label htmlFor="name" className="form-label">Client Name</label> 
                                    <Error errorName={errors?.name} /> 
                                    <select className="form-select"
                                        name="clientId"
                                        {...register(`clientId`, {
                                            required: `Client Name is required!`,
                                        })}
                                        >
                                            <option value="">Select Client Name</option>
                                            {
                                                clientData?.data?.map((category, idx)=>(
                                                <option value={category?.value}>{category?.label}</option>
                                                ))
                                            }   
                                        </select>  
                                        <Error errorName={errors?.clientId} />
                                </div>
                                <div className="col-lg-12">
                                    <label htmlFor="employeeId" className="form-label">Employee Name</label>
                                    <select className="form-select"
                                        name="employeeId"
                                        {...register(`employeeId`, {
                                            required: `Employee Name is required!`,
                                        })}
                                        >
                                            <option value="">Select Employee Name</option>
                                            {
                                                EmployeeData?.data?.map((category, idx)=>(
                                                <option value={category?.value}>{category?.label}</option>
                                                ))
                                            }   
                                        </select>  
                                        <Error errorName={errors?.employeeId} />
                                </div>
                            </div>
                            <div className="row g-3 mb-3"> 
                                <div className="col-lg-12"> 
                                    <label htmlFor="email" className="form-label">Project</label>
                                    <select className="form-select" name="projectType" {...register(`projectType`, { required: `Project is required!` })}>
                                        <option value="">Select Project</option> 
                                        {projectDropdown?.data?.map((val, idx) => (
                                            <option key={idx} value={val?.value}>{val?.label}</option>
                                        ))
                                        }
                                    </select>
 
                                </div>
                                <div className="col-lg-12">
                                    <label htmlFor="password" className="form-label">Meeting Date</label>
                                    <input type="date" className="form-control" name="scheduleDate" id="scheduleDate" {...register(`scheduleDate`, { required: `Meeting Date is required!`,
                  })}/>
                                <Error errorName={errors?.scheduleDate} />
                                </div>
                            </div> 
                            <div className="row g-3 mb-3"> 
                                <div className="col-lg-12"> 
                                    <label htmlFor="fromTime" className="form-label">From Time</label>
                                    <input type="time" className="form-control" name="fromTime" id="fromTime" {...register(`fromTime`, { required: `From Time is required!`,
                  })}/> 
                                <Error errorName={errors?.fromTime} /> 
                                </div> 
                                <div className="col-lg-12">
                                    <label htmlFor="toTime" className="form-label">To Time</label>
                                    <input type="time" className="form-control" name="toTime" id="toTime" {...register(`toTime`, { required: `To Time is required!`})}/>
                                </div>  
                            </div> 
                            {
                                (ScheduleId !== "" && typeof ScheduleId !== 'undefined') && (
                                    <div className="row g-3 mb-3">   
                                        <div className="col-lg-12"> 
                                            <label className="form-label">Status</label>
                                            <br />
                                            <label className="fancy-radio parsley-error">
                                                <input type="radio" name="status" value="Interested" checked={(status === "Interested") ? "checked": ""} onChange={(e) => { setStatus(e.target.value); }} required data-parsley-errors-container="#error-radio" data-parsley-multiple="status" data-parsley-id="43" />
                                                <span className="px-2"><i></i>Interested</span>
                                            </label>
                                            <label className="fancy-radio">
                                                <input type="radio" name="status" value="Request" checked={(status === "Request") ? "checked": ""} onChange={(e) => { setStatus(e.target.value); changeStatusRequest(ScheduleId); }} data-parsley-multiple="status" />
                                                <span className="px-2"><i></i>Request</span>
                                            </label>  
                                            <label className="fancy-radio">
                                                <input type="radio" name="status" value="Confirm" checked={(status === "Confirm") ? "checked": ""} onChange={(e) => { setStatus(e.target.value); changeStatusConfirm(); }} data-parsley-multiple="status" />
                                                <span className="px-2"><i></i>Confirm</span>
                                            </label> 
                                            <label className="fancy-radio">
                                                <input type="radio" name="status" value="Pending" checked={(status === "Pending") ? "checked": ""} onChange={(e) => { setStatus(e.target.value); }} data-parsley-multiple="status" />
                                                <span className="px-2"><i></i>Pending</span>
                                            </label> 
                                            <label className="fancy-radio">
                                                <input type="radio" name="status" value="Reject" checked={(status === "Reject") ? "checked": ""} onChange={(e) => { setStatus(e.target.value); }} data-parsley-multiple="status" />
                                                <span className="px-2"><i></i>Reject</span>
                                            </label>  
                                        </div> 
                                    </div> 
                                )
                            }  
                    </div>  
                    

                </Modal.Body>
                <Modal.Footer>                    
                    <button type="submit" className="btn btn-primary">{ScheduleId ? "Update " : "Add"}</button>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                </Modal.Footer>
                </form> 
            </Modal>

            <Modal centered show={isViewModal} size="lg" onHide={() => { setIsViewModal(false); }}>
                <div> 
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">View Meeting</Modal.Title>
                </Modal.Header>
                <Modal.Body> 

                <div className="deadline-form">

                    <div className="row g-3 mb-3"> 
                        <div className="col-sm-6">
                            <b> Client Name </b>
                        </div>
                        <div className="col-sm-6">
                            <div>{viewData?.clientId?.clientName}</div>
                        </div> 
                        <div className="col-sm-6">
                            <b> Employee Name </b>
                        </div> 
                        <div className="col-sm-6">
                            <div>{viewData?.employeeId?.employeeName}</div>
                        </div> 
                        <div className="col-sm-6">
                            <b> Project </b>
                        </div>
                        <div className="col-sm-6">
                            <div>{viewData?.projectType?.projectName}</div>
                        </div>  
                        <div className="col-sm-6">
                            <b> Meeting Date </b>
                        </div>
                        <div className="col-sm-6">
                            <div>{dayjs(viewData?.scheduleDate).format("DD-MM-YYYY")}</div>
                        </div> 
                        <div className="col-sm-6">
                            <b> From Time </b>
                        </div>
                        <div className="col-sm-6">
                            <div>{viewData?.fromTime}</div>
                        </div>  
                        <div className="col-sm-6">
                            <b> To Time </b>
                        </div>
                        <div className="col-sm-6">
                            <div>{viewData?.toTime}</div>
                        </div>  
                        <div className="col-sm-6">
                            <b> Status </b>
                        </div>
                        <div className="col-sm-6">
                            <div>{viewData?.status}</div>
                        </div>  
                    </div>    
                
                </div>   
                </Modal.Body>
                </div> 
            </Modal> 

            {/* Schedule Confirm modal */}
            <Modal show={isConfirmModal} centered size="xs" backdrop={isConfirmModal} onHide={() => { setIsConfirmModal(false) }}>
            
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Confirm Quotation</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <label htmlFor="confirmFile" className="form-label"> Status : <b>Request Accepted</b></label>
                    <br/>                    
                    
                    <label htmlFor="confirmFile" className="form-label"> File Upload</label>
                    <Uploader
                        imageUrl={imageUrl}
                        setImageUrl={setImageUrl}
                        folder="confirmedFile"
                        name="image"    
                    />
                </Modal.Body> 
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsConfirmModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleConfirmSchedule(ScheduleId)}>Submit</button>
                </Modal.Footer>
            </Modal>

            {/* Schedule delete modal */}
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete Meeting</Modal.Title> 
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete Meeting ?</p> 
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => deleteSchedule(ScheduleId)}>Delete</button>
                </Modal.Footer>
            </Modal>
            
        </div>
    )

}

export default Schedule;   